export default (theme) => ({
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    backgroundColor: 'rgba(10,26,60,0.55)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(255,255,255,0.12)',
  },
  navInner: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 28px',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logoWrap: {
    height: 44,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    flexShrink: 0,
    '& svg': {
      height: '100%',
      width: 'auto',
      filter: 'brightness(0) invert(1)',
    },
  },
  navLinks: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navLink: {
    color: 'rgba(255,255,255,0.8)',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 500,
    marginLeft: 32,
    whiteSpace: 'nowrap',
    '&:hover': {
      color: '#fff',
    },
  },
  navActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    '& > *:not(:first-child)': {
      marginLeft: 10,
    },
  },
});
